import { useSelector } from "react-redux";
import { Tab } from "@headlessui/react";
import { useBreadcrumb } from "../../hooks/useBreadcrumb";
import SimpleDataRow from "../../components/General/SimpleDataRow";
import AssistantInfoDialog from "../../components/AgentPortal/AgentProfile/Dialogs/AssistantInfoDialog";
import { useState, useEffect } from "react";
import { getAgentAssistant } from "../../service/userservice/getAgentAssistant";
import { useTranslation } from "react-i18next";
export default function AssistantDetails() {
  const { t } = useTranslation();
  const [pageLoad, setPageLoad] = useState(0);
  const { user } = useSelector((s) => s.user);
  const [openAgentAssistantDialog, setopenAgentAssistantDialog] =
    useState(false);
  useBreadcrumb(
    user.userId
      ? [
          { name: t("AgentAssistantDetails-Home"), url: "/dashboard" },
          { name: t("AgentAssistantDetails-Profile"), url: "/profile" },
          { name: t("AgentAssistantDetails-AssistantDetails"), url: "#" },
        ]
      : [
          { name: t("AgentAssistantDetails-Home"), url: "/" },
          { name: t("AgentAssistantDetails-AssistantDetails"), url: "#" },
        ]
  );
  useEffect(() => {
    if (pageLoad === 0) {
      getuserPermissions();
    }
  }, [pageLoad]);

  const [userAssistant, setuserAssistant] = useState([]);
  const getuserPermissions = async () => {
    if (pageLoad === 0) {
      let response = await getAgentAssistant(user?.agentID).catch((error) => {
        console.log(error);
      });
      setPageLoad(1);
      setuserAssistant(response);
    }
  };
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  return (
    <>
      <div className="container mb-8">
        <h1>{t("AgentAssistantDetails-AssistantPermissions")}</h1>
        <p>{t("AgentAssistantDetails-ManageAssistants")}</p>

        <hr />
      </div>
      <div className="container ui-component-spacing">
        <Tab.Group>
          <div className="flex-row md:flex">
            <div className="ui-card md:flex-grow px-2 p-1 md:px-4 md:mr-8">
              <Tab.List className="flex flex-row whitespace-nowrap">
                <Tab
                  className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${
                    selectedTabIndex === 0 ? "" : "text-ui-blue"
                  }`}
                  onClick={() => {
                    setSelectedTabIndex(0);
                  }}
                >
                  {t("AgentAssistantDetails-Active")}
                </Tab>
                <Tab
                  className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${
                    selectedTabIndex === 1 ? "" : "text-ui-blue"
                  }`}
                  onClick={() => {
                    setSelectedTabIndex(1);
                  }}
                >
                  {t("AgentAssistantDetails-Terminated")}
                </Tab>
              </Tab.List>
            </div>
            <div className="my-4 md:my-0 md:flex md:items-center">
              <button
                className="ui-btn-primary ui-btn-min-w mt-4"
                onClick={() => setopenAgentAssistantDialog(true)}
              >
                {t("AgentAssistantDetails-AddAssistant")}
              </button>
              {/*Manage AgentAssistant Preferences */}
              <AssistantInfoDialog
                dialogState={openAgentAssistantDialog}
                setDialogState={setopenAgentAssistantDialog}
                operation="add"
                getuserPermissions={getuserPermissions}
                setPageLoad={setPageLoad}
              />
            </div>
          </div>

          <Tab.Panels className="mt-6">
            <Tab.Panel>
              {userAssistant
                .filter((assistant) => assistant.isActive === 1)
                .map((assistant, idx) => (
                  <SimpleDataRow
                    key={`forms for assistant change - ${idx}`}
                    data={assistant}
                    type="assistant"
                    getuserPermissions={getuserPermissions}
                    setPageLoad={setPageLoad}
                  />
                ))}
            </Tab.Panel>
            <Tab.Panel>
              {userAssistant
                .filter((assistant) => assistant.isActive === 0)
                .map((assistantterminated, idx) => (
                  <SimpleDataRow
                    key={`forms for assistant change - ${idx}`}
                    data={assistantterminated}
                    type="assistantterminated"
                    getuserPermissions={getuserPermissions}
                    setPageLoad={setPageLoad}
                  />
                ))}
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </>
  );
}
